import { run } from './run';
import { sleep } from './sleep';

/** Wraps a promise with a version which rejects after the given period of time
 * if the inner promise has not yet resolved
 */
export const withTimeout = <T>(periodMs: number, promise: PromiseLike<T>): Promise<T> =>
  Promise.race([
    promise,
    run(async () => {
      await sleep(periodMs);
      throw new TimeoutError();
    }),
  ]);

export class TimeoutError extends Error {}
